import React from "react";
import MarketingLocationPage from "./MarketingLocationPage";

export default function MarketingAgenturOesterreich() {
  return <MarketingLocationPage locationKey="oesterreich" />;
}
